import React from "react";
import styles from "./team.module.css"; // Make sure to rename this to team.module.css
import Ellipse2 from "../assets/images/Ellipse 2.svg";
import Ellipse3 from "../assets/images/Ellipse 3.svg";
import { Header } from "../main-components/header";
import { FooterCom } from "../main-components/footer";
import JoinTeam from "../main-components/joinTeam";
import TeamMembers from "../main-components/TeamMember";

const Team = () => {
  return (
    <div className={styles.main}>
      <div className={styles.background}>
        <div className={styles.overlap}>
          <img className={styles.ellipse} alt="Ellipse" src={Ellipse3} />
        </div>
        <div className={styles.overlap2}>
          <img className={styles.ellipse2} alt="Ellipse" src={Ellipse2} />
          <div className={styles.headerInstance}>
            <Header
              LOGOBcalLogoRemovebg={require("../assets/images/bcal-logo-removebg-preview-1.png")}
            />
          </div>
        </div>
        <div className={styles.contentArea}>
          <div className={styles.joinTeamWrapper}>
            <JoinTeam />
          </div>
          <div className={styles.teamMembersWrapper}>
            <TeamMembers />
          </div>
        </div>
      </div>
      <div className={styles.footerInstance}>
        <FooterCom
          img={require("../assets/images/screenshot-20240423-at-9021.png")}
          screenshot={require("../assets/images/screenshot-20240423-at-9031.png")}
        />
      </div>
    </div>
  );
};

export default Team;
